export default __webpack_public_path__ + "static/media/pocloader.75cae4f8.gif";